import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, Grid} from 'semantic-ui-react';
import {parseOriginWarehousesAllowed, parseAgenciesValues, parseClients} from '../../../common/util/options';
import {PANES_INDICES} from '../../../common/dictionaries/binningInvoicing';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import EnablePriceChange from './modal/enableChangePrice';
import FiltersButtons from './filtersButtons';

class InvoicingFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'clientTmp': '',
      'clientSelected': '',
      'agencyTmp': '',
      'agencySelected': '',
      'warehouseTmp': '',
      'warehouseSelected': '',
      'showData': false,
      'invoiceSaving': false,
      'isPriceEditionEnabled': false,
      'priceEditionReason': '',
    };
    this.changeClient = this.changeClient.bind(this);
    this.changeAgency = this.changeAgency.bind(this);
    this.changeWarehouse = this.changeWarehouse.bind(this);
    this.checkIsInvoiceSaved = this.checkIsInvoiceSaved.bind(this);
    this.handleEnablePriceEditionClick = this.handleEnablePriceEditionClick.bind(this);
  }

  componentDidMount() {
    const {client, warehouse} = this.props;
    const activeTabIsInternalsOrders = client && warehouse;
    const dealerFilter = activeTabIsInternalsOrders ? 'clients' : 'importers';
    this.props.fetchDealers(dealerFilter);

    if (activeTabIsInternalsOrders) {
      this.setState({
        'clientTmp': client,
        'clientSelected': client,
        'warehouseTmp': warehouse,
        'warehouseSelected': warehouse,
      }, () => this.onSearchClick());
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {invoiceSaved, activeTabIndex} = this.props;
    if ((invoiceSaved && prevState.invoiceSaving) ||
      (activeTabIndex !== prevProps.activeTabIndex)) {
      this.setState({
        'clientTmp': '',
        'clientSelected': '',
        'warehouseTmp': '',
        'warehouseSelected': '',
        'showData': false,
        'invoiceSaving': false,
        'agencySelected': '',
        'isPriceEditionEnabled': false,
        'priceEditionReason': '',
      });
    }
  }

  changeClient(event, data) {
    this.setState({'clientTmp': data.value}, () => this.updateDataForClient());
  }

  updateDataForClient() {
    const {clientSelected, clientTmp} = this.state;
    const {activeTabIndex} = this.props;
    if (clientSelected !== clientTmp) {
      const isManualInvoiceTab = activeTabIndex === PANES_INDICES.MANUAL_INVOICING;
      if (isManualInvoiceTab) {
        this.props.fetchAgenciesByDealer({'dealerId': clientTmp});
      }
      this.setState({
        'clientSelected': clientTmp,
        'agencySelected': '',
        'agencyTmp': '',
        'showData': false,
      }, () => this.getManualInvoiceData());
    }
  }

  changeAgency(event, data) {
    this.setState({'agencyTmp': data.value}, () => this.updateDataForAgency());
  }

  updateDataForAgency() {
    const {agencySelected, agencyTmp} = this.state;
    if (agencySelected !== agencyTmp) {
      this.setState({
        'agencySelected': agencyTmp,
        'showData': false,
      }, () => this.getManualInvoiceData());
    }
  }

  getWarehouses() {
    const isManualInvoiceTab = this.state.activeTabIndex === PANES_INDICES.MANUAL_INVOICING;
    const scope = isManualInvoiceTab ? 'Facturar' : 'Facturar Pedido Interno';
    const warehousesAllowed = [];
    this.props.warehouses.forEach((element) => {
      if (hasAccessPermission(this.props.permissions, `Bodega ${element.code}`, scope)) {
        warehousesAllowed.push(element);
      }
    });
    return parseOriginWarehousesAllowed(warehousesAllowed);
  }

  changeWarehouse(event, data) {
    this.setState({'warehouseTmp': data.value}, () => this.updateDataForWarehouse());
  }

  updateDataForWarehouse() {
    const {warehouseSelected, warehouseTmp} = this.state;
    if (warehouseSelected !== warehouseTmp) {
      this.setState({
        'warehouseSelected': warehouseTmp,
        'showData': false,
      }, () => this.getManualInvoiceData());
    }
  }

  getManualInvoiceData() {
    const {clientSelected, agencySelected, warehouseSelected} = this.state;
    const {activeTabIndex} = this.props;
    const isManualInvoiceTab = activeTabIndex === PANES_INDICES.MANUAL_INVOICING;
    this.props.updateSelectedFilters(clientSelected, agencySelected, warehouseSelected);
    if (isManualInvoiceTab && clientSelected && agencySelected && warehouseSelected) {
      this.props.fetchManualInvoiceData(clientSelected, warehouseSelected, agencySelected);
    }
  }

  renderDeliveryPointTitle(isManualInvoiceTab) {
    if (isManualInvoiceTab) {
      return (
        <Grid.Column width={2}>
          <h4>Punto de Entrega</h4>
        </Grid.Column>
      );
    }
  }

  handleEnablePriceEditionClick(reason) {
    this.setState({'isPriceEditionEnabled': true});
    this.setState({'priceEditionReason': reason});
  }

  renderChangeValuesButton(isManualInvoiceTab) {
    const isUserAllowedToChangePrices = this.checkUserAllowedToChangePrice();
    const {isPriceEditionEnabled} = this.state;
    if (!isUserAllowedToChangePrices || !isManualInvoiceTab) {
      return null;
    }
    return (
      <Grid.Column width={2}>
        <EnablePriceChange onClick={this.handleEnablePriceEditionClick}
          isPriceEditionEnabled={isPriceEditionEnabled}
        />
      </Grid.Column>
    );
  }

  checkIsInvoiceSaved() {
    this.setState({'invoiceSaving': true});
  }

  checkUserAllowedToChangePrice() {
    return hasAccessPermission(this.props.permissions, resources.Invoicing, scopes.Edit);
  }

  getFieldWidth(isManualInvoiceTab, isUserAllowedToChangePrices) {
    if (isManualInvoiceTab && isUserAllowedToChangePrices) {
      return 2;
    } else if (isManualInvoiceTab) {
      return 3;
    }
    return 5;
  }

  renderClientsDropdown(isManualInvoiceTab) {
    const {deleting, invoicing, savingLineInfo, loadingClients, clients} = this.props;
    const {clientTmp} = this.state;
    const isUserAllowedToChangePrices = this.checkUserAllowedToChangePrice();
    const fieldWidth = this.getFieldWidth(isManualInvoiceTab, isUserAllowedToChangePrices);
    return (
      <Grid.Column width={fieldWidth}>
        <Dropdown
          selection
          options={parseClients(clients)}
          search
          value={clientTmp}
          disabled={loadingClients || savingLineInfo || deleting || invoicing}
          loading={loadingClients}
          onChange={this.changeClient}
          placeholder='Clientes'
          noResultsMessage='Cliente no encontrado'
        />
      </Grid.Column>
    );
  }

  renderAgenciesDropdown(isManualInvoiceTab) {
    if (!isManualInvoiceTab) {
      return null;
    }

    const isUserAllowedToChangePrices = this.checkUserAllowedToChangePrice();
    const fieldWidth = this.getFieldWidth(isManualInvoiceTab, isUserAllowedToChangePrices);
    const {deleting, invoicing, savingLineInfo, loadingAgencies, agencies} = this.props;
    const {clientTmp, agencyTmp} = this.state;
    return (
      <Grid.Column width={fieldWidth}>
        <Dropdown
          selection
          options={parseAgenciesValues(agencies)}
          search
          value={agencyTmp}
          disabled={loadingAgencies || !clientTmp || savingLineInfo || deleting || invoicing}
          loading={loadingAgencies}
          onChange={this.changeAgency}
          placeholder='Agencias'
          noResultsMessage='Agencia no encontrada'
        />
      </Grid.Column>
    );
  }

  render() {
    const {warehouseTmp, clientSelected, agencySelected,
      warehouseSelected, priceEditionReason} = this.state;
    const {activeTabIndex, deleting, invoicing, savingLineInfo,
      loadingWarehouses, updateShowDataState} = this.props;
    const isManualInvoiceTab = activeTabIndex === PANES_INDICES.MANUAL_INVOICING;
    return (
      <div className='filters-section'>
        <Grid textAlign='left'>
          <Grid.Row>
            <Grid.Column width={1}>
              <h4>Cliente</h4>
            </Grid.Column>
            {this.renderClientsDropdown(isManualInvoiceTab)}
            {this.renderDeliveryPointTitle(isManualInvoiceTab)}
            {this.renderAgenciesDropdown(isManualInvoiceTab)}
            <Grid.Column width={1}>
              <h4>Bodega</h4>
            </Grid.Column>
            <Grid.Column width={isManualInvoiceTab ? 3 : 5}>
              <Dropdown
                selection
                options={this.getWarehouses()}
                search
                value={warehouseTmp}
                disabled={loadingWarehouses || savingLineInfo || deleting || invoicing}
                loading={loadingWarehouses}
                onChange={this.changeWarehouse}
                placeholder='Bodegas'
                noResultsMessage='Bodega no encontrada'
              />
            </Grid.Column>
            <Grid.Column width={isManualInvoiceTab ? 3 : 4} textAlign='right'>
              <FiltersButtons
                checkIsInvoiceSaved={this.checkIsInvoiceSaved} clientSelected={clientSelected}
                agencySelected={agencySelected} activeTabIndex={activeTabIndex}
                warehouseSelected={warehouseSelected} priceEditionReason={priceEditionReason}
                updateShowDataState={updateShowDataState}
              />
            </Grid.Column>
            {this.renderChangeValuesButton(isManualInvoiceTab)}
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'deleting': state.invoicing.deleting,
    'invoicing': state.invoicing.invoicing,
    'loadingClients': state.dealer.loading,
    'clients': state.dealer.list,
    'loadingAgencies': state.dealer.loadingAgencies,
    'agencies': state.dealer.agenciesList,
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'clientInfo': state.invoicing.clientInfo,
    'loadingInternalsOrders': state.internalOrder.loading,
    'internalsOrdersList': state.internalOrder.internalsOrdersList,
    'invoiceSaved': state.invoicing.invoiceSaved,
    'savingLineInfo': state.invoicing.savingLineInfo,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchAgenciesByDealer,
  fetchManualInvoiceData,
  fetchDealers,
  fetchWarehouses,
  fetchInternalsOrdersList,
} = Actions;

export default connect(mapStateToProps, {
  fetchAgenciesByDealer,
  fetchManualInvoiceData,
  fetchDealers,
  fetchWarehouses,
  fetchInternalsOrdersList,
})(InvoicingFilters);
